import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import mixpanel from 'mixpanel-browser';
import { PROFILE_STYLES, PROFILE_TEXTS } from '../consts';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { useStore } from '../../../store';
import { AccountDetailsModal } from '../../../flows/profile/components/AccountDetailsModal';
import { UserMessage } from '../../../DesignSystem/LiliUserMessage/UserMessage';
import { ISummaryData } from '../../../types';

export const AccountDetailsBlock = () => {
  const { t } = useTranslation();
  const getPrimaryAccount = useStore((state) => state.getPrimaryAccount);
  const summaryData: ISummaryData = useStore((state) => state.summary);
  const [isAccountDetailsShown, setIsAccountDetailsShown] = useState<boolean>(false);

  const accountDetails = useMemo(
    () => ({
      achRoutingNumber: getPrimaryAccount().routingNumber,
      wireRoutingNumber: getPrimaryAccount().wireRoutingNumber,
      achNumber: getPrimaryAccount().achAccountNumber,
      swiftCode: getPrimaryAccount().swiftCode,
      shouldShowNumberChange: false,
    }),
    [summaryData],
  );

  const achNumberSuffix = useMemo(() => {
    const nChars = 4;
    const value = summaryData.accounts[0].achAccountNumber;
    const suffix = value.slice(-nChars);
    return `(...${suffix})`;
  }, [summaryData]);

  return (
    <div className='flex items-center gap-[8px]'>
      {accountDetails.shouldShowNumberChange && (
        <div className='relative rounded-[50%] min-w-[12px] min-h-[12px]'>
          <div className='min-w-[12px] min-h-[12px] rounded-[50%] bg-action01 flex items-center justify-center scaleWithOpacityAnimation' />
          <div className='w-[4px] h-[4px] rounded-[50%] bg-action03 absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2' />
        </div>
      )}
      <Button
        onClick={() => setIsAccountDetailsShown(true)}
        className='w-full'
        id='account-details-item'
        childElement={
          <div className={PROFILE_STYLES.ACCOUNT_DETAILS_SECTION_WRAPPER}>
            <div className='flex items-center gap-[6px]'>
              <Heading
                title={t(PROFILE_TEXTS.ACCOUNT_DETAILS_HEADER)}
                className={PROFILE_STYLES.ACCOUNT_DETAILS_SECTION_HEADER}
              />
              <Heading title={achNumberSuffix} className={PROFILE_STYLES.ACCOUNT_DETAILS_SECTION_ACH} />
            </div>
            <Heading
              title={t(PROFILE_TEXTS.ACCOUNT_DETAILS_CTA)}
              className={PROFILE_STYLES.ACCOUNT_DETAILS_SECTION_CTA}
              id='elButtonShowDetails'
            />
          </div>
        }
      />
      {isAccountDetailsShown && (
        <UserMessage onClick={() => setIsAccountDetailsShown(false)} id='AccountDetailsModal'>
          <AccountDetailsModal
            fullName={`${summaryData.customer.firstName} ${summaryData.customer.lastName}`}
            achRoutingNumber={accountDetails?.achRoutingNumber}
            wireRoutingNumber={accountDetails?.wireRoutingNumber}
            achNumber={accountDetails?.achNumber}
            swiftCode={accountDetails?.swiftCode}
            onClose={() => {
              mixpanel.track('Act on Menu Screen', { Action: 'Account Details' });
              setIsAccountDetailsShown(false);
            }}
          />
        </UserMessage>
      )}
    </div>
  );
};
